import Vue from 'vue'
import Router from 'vue-router'
import Cardapio from "../components/Paginas/Cardapio";
import Produto from "../components/Paginas/Produto";
import Pedido from "../components/Paginas/Pedido";
import Erro from "../components/Paginas/Erro";
import Inicio from "../components/Paginas/Inicio";
import Pesquisa from "../components/Paginas/Pesquisa";
import ReciboPagamentoLinkMercadoPago from "../components/Paginas/ReciboPagamentoLinkMercadoPago";
import PedidoEnviado from "../components/Paginas/PedidoEnviado";

import NovoCadastro from "../components/Paginas/AreaCliente/NovoCadastro";
import PreCadastro from "../components/Paginas/AreaCliente/PreCadastro";
import Login from "../components/Paginas/AreaCliente/Login";
import ValidarCodigo from "../components/Paginas/AreaCliente/ValidarCodigo";
import CadastroRealizadoSucesso from "../components/Paginas/AreaCliente/CadastroRealizadoSucesso";
import PerfilCliente from "../components/Paginas/AreaCliente/PerfilCliente";
import PedidosCliente from "../components/Paginas/AreaCliente/PedidosCliente";
import UltimoPedido from "../components/Paginas/AreaCliente/UltimoPedido";
import StatusPedido from "../components/Paginas/Pedido/StatusPedido";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Erro',
      component: Erro
    },
    {
      path: '/:empresa',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/:empresa/pesquisar/',
      name: 'Pesquisa',
      component: Pesquisa
    },
    {
      path: '/:empresa/menu',
      name: 'Cardapio',
      component: Cardapio
    },
    {
      path: '/:empresa/menu/produto/:id',
      name: 'Produto',
      component: Produto
    },
    {
      path: '/:empresa/pedido',
      name: 'Pedido',
      component: Pedido
    },
    {
      path: '/:empresa/pedido/status/:id',
      name: 'StatusPedido',
      component: StatusPedido
    },
    {
      path: '/pagamentos/mercadopago/rastrear/:id',
      name: 'ReciboPagamentoLinkMercadoPago',
      component: ReciboPagamentoLinkMercadoPago
    },
    {
      path: '/404/nao-localizado',
      name: 'EmpresaNaoLocalizada',
      component: Erro
    },
    {
      path: '/:empresa/pedido-enviado',
      name: 'PedidoEnviado',
      component: PedidoEnviado
    },
    {
      path: '/:empresa/novo-cadastro',
      name: 'NovoCadastro',
      component: NovoCadastro
    },
    {
      path: '/:empresa/pre-cadastro',
      name: 'PreCadastro',
      component: PreCadastro
    },
    {
      path: '/:empresa/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/:empresa/validar-codigo',
      name: 'ValidarCodigo',
      component: ValidarCodigo
    },
    {
      path: '/:empresa/cadastro-realizado-sucesso',
      name: 'CadastroRealizadoSucesso',
      component: CadastroRealizadoSucesso
    },
    {
      path: '/:empresa/cliente-perfil',
      name: 'PerfilCliente',
      component: PerfilCliente
    },
    {
      path: '/:empresa/cliente-pedidos',
      name: 'PedidosCliente',
      component: PedidosCliente
    },
    {
      path: '/:empresa/cliente-ultimo-pedido',
      name: 'UltimoPedido',
      component: UltimoPedido
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js